/**
 * Human-readable labels for OCSF class_uid / activity_id codes used by
 * hub-wifi. The full OCSF catalog has many more values; this file only
 * names the codes hub-wifi actually emits (see
 * docs/plans/2026-05-21-ocsf-audit-refactor.md mapping table).
 */
export const OCSF_CLASS_LABEL: Record<number, string> = {
  3001: 'Account Change',
  3002: 'Authentication',
  3003: 'Authorize Session',
  3004: 'Entity Management',
  3005: 'User Access Management',
  3006: 'Group Management',
  6003: 'API Activity',
  6005: 'Web Resources Access',
}

export const OCSF_ACTIVITY_LABEL: Record<number, string> = {
  1: 'Create',
  2: 'Read',
  3: 'Update',
  4: 'Delete',
  99: 'Other',
}

export const OCSF_STATUS_LABEL: Record<number, string> = {
  0: 'Unknown',
  1: 'Success',
  2: 'Failure',
  99: 'Other',
}

export const OCSF_SEVERITY_LABEL: Record<number, string> = {
  0: 'Unknown',
  1: 'Informational',
  2: 'Low',
  3: 'Medium',
  4: 'High',
  5: 'Critical',
  6: 'Fatal',
  99: 'Other',
}

// TODO(review): unify QueryRow/OcsfQueryRow with apps/api/src/audit-do.ts
// (reported by ring:consequences-reviewer on 2026-05-24, severity: Medium).
// The shapes are compatible enough for the UI to work; consolidation requires
// exporting the full OcsfEvent envelope from shared and refactoring the DO.
export interface OcsfQueryRow {
  uid: string
  time: number
  envelope: {
    class_uid: number
    category_uid: number
    activity_id: number
    type_uid: number
    severity_id: number
    status_id: number
    actor: { user: { uid: string; type_id?: number } }
    src_endpoint?: { ip: string }
    api?: { operation?: string }
    resources?: Array<{ type: string; uid: string }>
    error?: { code?: string; message?: string }
    unmapped?: Record<string, string | number | boolean | null>
    trace_uid?: string
  }
  detail: unknown | null
}

/** Read-time resolved identity for an OCSF actor `uid`. Never persisted. */
export interface ActorIdentity {
  name: string
  email: string
  companyName: string | null
}
